<template>
  <div>
    <!--类型切换 + 筛选-->
    <Row type="flex" :space-x="10" class="margin-right-left padding-top" align="middle">
      <Cell>
        <Radio v-if="!isAnnual" type="button" v-model="declareType" :datas="typeDatas" @change="onTypeChange"></Radio>
      </Cell>
      <Cell>
        <DatePicker v-model="filter.year" type="year" format="yyyy" style="width:110px" placeholder="年度"></DatePicker>
      </Cell>
      <Cell v-if="declareType === 1">
        <Select v-model="filter.month" style="width:90px" :allow-clear="true" placeholder="月份">
          <Option v-for="m in 12" :value="m" :key="m">{{ m }}月</Option>
        </Select>
      </Cell>
      <Cell>
        <input class="h-input" v-model="filter.name" placeholder="投资者姓名" style="width:130px">
      </Cell>
      <Cell>
        <Button color="primary" @click="loadList">查询</Button>
      </Cell>
      <Cell>
        <Button color="success" @click="openAdd">新增记录</Button>
      </Cell>
    </Row>

    <!--列表-->
    <div class="h-panel-body padding-top">
      <Table :datas="list" :border="true" :loading="loading">
        <TableItem title="所属期" :width="130">
          <template slot-scope="{data}">
            {{ data.year }}<span v-if="declareType === 1">-{{ String(data.month).padStart(2, '0') }}</span>
          </template>
        </TableItem>
        <TableItem title="投资者" prop="name" :width="100"></TableItem>
        <TableItem title="证件号码" prop="certNo" :width="170"></TableItem>
        <TableItem title="征收方式" prop="collectType" :width="110"></TableItem>
        <TableItem title="收入总额" align="right">
          <template slot-scope="{data}">{{ money(data.totalIncome) }}</template>
        </TableItem>
        <TableItem title="成本费用" align="right">
          <template slot-scope="{data}">{{ money(data.costExpense) }}</template>
        </TableItem>
        <TableItem title="应纳税所得额" align="right">
          <template slot-scope="{data}">{{ money(data.taxableIncome) }}</template>
        </TableItem>
        <TableItem title="税率" :width="80" align="center">
          <template slot-scope="{data}">{{ rateText(data.rate) }}</template>
        </TableItem>
        <TableItem title="速算扣除数" align="right">
          <template slot-scope="{data}">{{ money(data.quickDeduction) }}</template>
        </TableItem>
        <TableItem title="应补(退)税额" align="right">
          <template slot-scope="{data}">
            <b :class="Number(data.supplementTax) > 0 ? 'tax-need' : ''">{{ money(data.supplementTax) }}</b>
          </template>
        </TableItem>
        <TableItem title="状态" :width="90" align="center">
          <template slot-scope="{data}">
            <Tag :color="data.declareStatus === 1 ? 'success' : 'warning'">
              {{ data.declareStatus === 1 ? '已申报' : '未申报' }}
            </Tag>
          </template>
        </TableItem>
        <TableItem title="操作" :width="80" align="center">
          <span slot-scope="{data}" class="link" @click="openEdit(data)">编辑</span>
        </TableItem>
      </Table>
      <Pagination :page="filter.page" size="small" :total="total" @change="onPage" class="margin-top text-right"></Pagination>
    </div>

    <!--编辑弹窗-->
    <Modal v-model="modal" :title="modalTitle" width="820">
      <div class="form-scroll">
        <Form ref="form" mode="twocolumn" :labelWidth="150" :model="form" :rules="validationRules">
          <FormItem label="年度" prop="year">
            <input type="number" v-model.number="form.year">
          </FormItem>
          <FormItem v-if="declareType === 1" label="月份" prop="month">
            <input type="number" min="1" max="12" v-model.number="form.month">
          </FormItem>
          <FormItem label="投资者姓名" prop="name">
            <input type="text" v-model="form.name">
          </FormItem>
          <FormItem label="证件号码" prop="certNo">
            <input type="text" v-model="form.certNo">
          </FormItem>
          <FormItem label="征收方式">
            <Select v-model="form.collectType">
              <Option value="据实预缴">据实预缴</Option>
              <Option value="核定征收">核定征收</Option>
              <Option value="按上年应纳税所得额预缴">按上年应纳税所得额预缴</Option>
            </Select>
          </FormItem>
          <FormItem v-if="declareType === 1" label="本期减除投资者费用">
            <HSwitch v-model="feeSwitch"></HSwitch>
          </FormItem>
          <FormItem label="收入总额">
            <input type="number" v-model.number="form.totalIncome">
          </FormItem>
          <FormItem label="国债利息收入" v-if="declareType === 2">
            <input type="number" v-model.number="form.nationalDebtIncome">
          </FormItem>
          <FormItem label="成本费用">
            <input type="number" v-model.number="form.costExpense">
          </FormItem>
          <FormItem label="利润总额" v-if="declareType === 2">
            <input type="number" v-model.number="form.totalProfit">
          </FormItem>
          <FormItem label="纳税调整增加额" v-if="declareType === 2">
            <input type="number" v-model.number="form.taxIncrease">
          </FormItem>
          <FormItem label="纳税调整减少额" v-if="declareType === 2">
            <input type="number" v-model.number="form.taxDecrease">
          </FormItem>
          <FormItem label="可弥补以前年度亏损" v-if="declareType === 2">
            <input type="number" v-model.number="form.makeUpLoss">
          </FormItem>
          <FormItem label="应税所得率(%)" v-if="declareType === 1">
            <input type="number" v-model.number="ratePercent">
          </FormItem>
          <FormItem label="分配比例(%)">
            <input type="number" v-model.number="ratioPercent">
          </FormItem>
          <FormItem label="养老保险">
            <input type="number" v-model.number="form.pension">
          </FormItem>
          <FormItem label="医疗保险">
            <input type="number" v-model.number="form.medical">
          </FormItem>
          <FormItem label="失业保险">
            <input type="number" v-model.number="form.unemployment">
          </FormItem>
          <FormItem label="住房公积金">
            <input type="number" v-model.number="form.housingFund">
          </FormItem>
          <FormItem label="商业健康保险">
            <input type="number" v-model.number="form.commercialHealth">
          </FormItem>
          <FormItem label="税延养老保险">
            <input type="number" v-model.number="form.taxDeferredPension">
          </FormItem>
          <FormItem label="其他扣除">
            <input type="number" v-model.number="form.otherDeduction">
          </FormItem>
          <FormItem label="已缴税额">
            <input type="number" v-model.number="form.paidTax">
          </FormItem>
          <FormItem label="准予扣除捐赠额">
            <input type="number" v-model.number="form.donation">
          </FormItem>
          <FormItem label="减免税额">
            <input type="number" v-model.number="form.taxReduction">
          </FormItem>
          <FormItem label="备注">
            <textarea v-model="form.remark" rows="2"></textarea>
          </FormItem>
        </Form>
      </div>
      <div slot="bottom">
        <Button @click="modal = false">取消</Button>
        <Button color="primary" @click="doSave" :loading="saving">保存</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
const emptyForm = {
  id: null, year: null, month: null, name: '', certNo: '',
  collectType: '据实预缴', totalIncome: 0, nationalDebtIncome: 0, costExpense: 0, totalProfit: 0,
  taxIncrease: 0, taxDecrease: 0, makeUpLoss: 0,
  taxableIncomeRate: 1, distributionRatio: 1, investorFeeUsed: 1,
  pension: 0, medical: 0, unemployment: 0, housingFund: 0,
  commercialHealth: 0, taxDeferredPension: 0, otherDeduction: 0,
  paidTax: 0, donation: 0, taxReduction: 0, remark: ''
};

export default {
  name: 'ScjyDeclare',
  data() {
    let now = new Date();
    return {
      declareType: this.$route.meta.annual ? 2 : 1,
      typeDatas: [{key: 1, title: '预缴申报'}, {key: 2, title: '年度汇缴'}],
      filter: {year: now.getFullYear(), month: now.getMonth() + 1, name: '', page: 1},
      list: [],
      total: 0,
      loading: false,
      modal: false,
      saving: false,
      form: HeyUtils.copy(emptyForm),
      feeSwitch: true,
      ratePercent: 100,
      ratioPercent: 100,
      validationRules: {
        required: ['year', 'name', 'certNo']
      }
    };
  },
  computed: {
    isAnnual() {
      return !!this.$route.meta.annual;
    },
    modalTitle() {
      return this.declareType === 1 ? '生产经营所得预缴申报' : '生产经营所得年度汇缴';
    }
  },
  methods: {
    money(val) {
      let n = Number(val);
      return isNaN(n) ? '0.00' : n.toFixed(2);
    },
    rateText(rate) {
      let n = Number(rate);
      return isNaN(n) ? '-' : (n * 100).toFixed(0) + '%';
    },
    onTypeChange() {
      this.filter.page = 1;
      this.loadList();
    },
    loadList() {
      this.loading = true;
      let params = {
        declareType: this.declareType, year: this.filter.year, name: this.filter.name,
        page: this.filter.page, pageSize: 20
      };
      if (this.declareType === 1) {
        params.month = this.filter.month;
      }
      this.$api.pro.scjy.list(params).then(({data}) => {
        this.list = data.results || [];
        this.total = data.total || 0;
      }).finally(() => this.loading = false);
    },
    onPage(page) {
      this.filter.page = page;
      this.loadList();
    },
    openAdd() {
      this.form = HeyUtils.copy(emptyForm);
      this.form.year = this.filter.year;
      this.form.month = this.filter.month;
      this.feeSwitch = true;
      this.ratePercent = 100;
      this.ratioPercent = 100;
      this.modal = true;
    },
    openEdit(row) {
      this.form = HeyUtils.copy(row);
      this.feeSwitch = row.investorFeeUsed !== 0;
      this.ratePercent = Math.round(Number(row.taxableIncomeRate) * 100);
      this.ratioPercent = Math.round(Number(row.distributionRatio) * 100);
      this.modal = true;
    },
    doSave() {
      let validResult = this.$refs.form.valid();
      if (!validResult.result) {
        return;
      }
      this.form.declareType = this.declareType;
      this.form.investorFeeUsed = this.feeSwitch ? 1 : 0;
      this.form.taxableIncomeRate = this.ratePercent / 100;
      this.form.distributionRatio = this.ratioPercent / 100;
      this.saving = true;
      this.$api.pro.scjy.save(this.form).then(() => {
        this.$Message.success('保存成功，税额已按规定计算');
        this.modal = false;
        this.loadList();
      }).finally(() => this.saving = false);
    }
  },
  mounted() {
    this.loadList();
  }
}
</script>

<style lang="less" scoped>
.tax-need {
  color: #ed4014;
}
.link {
  color: #2d8cf0;
  cursor: pointer;
}
.form-scroll {
  max-height: 460px;
  overflow-y: auto;
}
.margin-top {
  margin-top: 10px;
}
</style>
